import { BaseSelect } from '@/shared/components'
import { FilterButton } from '@/shared/components/FilterButton/FilterButton'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'
import { OptionModel } from '@/shared/lib/types'
import { useIsMobile } from '@/shared/utils'

type RequisitesHeaderProps = {
  selectedBtn: string
  selectFilterBtn: (label: string) => void
  setSearch: (search: string) => void
  onChangeStatus: (value: string | number | null) => void
  selectedStatus: string | null
  setSelectedStatus: (value: string | null) => void
  setSkip: (value: number) => void
}

export const detailFilterButtons: FilterButtonModel[] = [
  { name: 'Все', label: 'all', index: 0 },
  { name: 'Активные', label: 'active', index: 1 },
  { name: 'Приостановленые', label: 'disabled', index: 2 },
  { name: 'Заблокированные', label: 'blocked', index: 4 },
]
export const detailChangeStatus: OptionModel[] = [
  { label: 'Активировать', value: 'activete', index: 1 },
  { label: 'Остановить', value: 'stop', index: 2 },
  { label: 'Заблокировать', value: 'block', index: 3 },
]

export const RequisitesHeader = ({
  selectedBtn,
  selectFilterBtn,
  setSearch,
  onChangeStatus,
  selectedStatus,
  setSelectedStatus,
  setSkip,
}: RequisitesHeaderProps) => {
  const isMobile = useIsMobile()

  return (
    <div>
      {isMobile ? (
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-2 w-full">
            <div className="flex-1 min-w-[150px]">
              <BaseSelect
                placeholder="Изменить статус"
                options={detailChangeStatus}
                value={selectedStatus}
                onChange={(value) => {
                  setSelectedStatus(value as string)
                  onChangeStatus(value)
                }}
              />
            </div>
            <SearchInput
              onChange={(event) => {
                const numericOnly = event.target.value.replace(/\D/g, '')
                setSearch(numericOnly)
              }}
              minWidth="150px"
              className="flex-1"
            />
          </div>
          <div className="flex gap-1 overflow-x-auto whitespace-nowrap scrollbar-hide">
            {detailFilterButtons?.map((b) => (
              <FilterButton
                key={b.index}
                name={b.name}
                onClick={() => {
                  selectFilterBtn(b.label)
                  setSkip(0)
                }}
                selected={b.label === selectedBtn}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="flex flex-wrap justify-between items-center gap-2">
          <div className="flex items-center gap-6">
            <div className="flex gap-1 overflow-x-auto md:overflow-x-visible scrollbar-hide">
              {detailFilterButtons?.map((b) => (
                <FilterButton
                  key={b.index}
                  name={b.name}
                  onClick={() => {
                    selectFilterBtn(b.label)
                    setSkip(0)
                  }}
                  selected={b.label === selectedBtn}
                />
              ))}
            </div>
            <div className="w-50 min-w-[150px]">
              <BaseSelect
                placeholder="Изменить статус"
                options={detailChangeStatus}
                value={selectedStatus}
                onChange={(value) => {
                  setSelectedStatus(value as string)
                  onChangeStatus(value)
                }}
              />
            </div>
          </div>
          <SearchInput
            onChange={(event) => {
              const numericOnly = event.target.value.replace(/\D/g, '')
              setSearch(numericOnly)
            }}
          />
        </div>
      )}
    </div>
  )
}
